<template>
    <h1 class="font-semibold text-2xl text-blue-700 leading-tight mb-6">
        <slot />
    </h1>
</template>
